<div class="header">
  <h3>Admin</h3>
</div>
<div class="row">
  <div class="col tab-menu">
    <admin-nav-menu [currentTab]="'offices'"></admin-nav-menu>
  </div>

  <div class="col col-constrained">
    <fieldset>
      <legend>Offices</legend>
      <table class="table table-sm table-align-middle">
        <thead>
          <tr>
            <th style="width: 1rem;">Id</th>
            <th style="width: 6rem;">Region</th>
            <th>Name</th>
          </tr>
        </thead>
        <tbody>
          @if (activeOffices.length == 0) {
            <tr>
              <td colspan="3">
                <span class="d-block p-2 text-center">
                  <i class="fa fa-ban text-danger"></i>
                  No data to display&hellip;
                </span>
              </td>
            </tr>
          }
          @for (office of activeOffices; track office) {
            <tr>
              <td class="px-3 font-weight-bold">{{office.id}}</td>
              <td>{{office.regionCode}}</td>
              <td>{{office.name}}</td>
            </tr>
          }
        </tbody>
      </table>
    </fieldset>
  </div>
</div>
